import { FC, memo } from "react";
import { preStaticUrl } from "../../../../../constants/env_config";
import { isEqual } from "lodash";
import "./commuinty.scss";
import SvgComponent from "../../../../../components/SvgComponent/SvgComponent";
interface IProps {
  className: string;
}
const CommunityLink: FC<IProps> = memo(({ className }: IProps) => {
  return (
    <div className={`${className} commuinty`}>
      <a href="https://t.me/zyphernetwork" target="_blank" rel="noreferrer">
        <SvgComponent
          className="community_svg"
          src={preStaticUrl + "/img/layout/telegram.svg"}
        />
      </a>
      <a
        href="https://twitter.com/Zypher_Network"
        target="_blank"
        rel="noreferrer"
      >
        <SvgComponent
          className="community_svg"
          src={preStaticUrl + "/img/layout/twitter.svg"}
        />
      </a>
      <a
        href="https://discord.gg/muWwuPb8zz"
        target="_blank"
        rel="noreferrer"
      >
        <SvgComponent
          className="community_svg"
          src={preStaticUrl + "/img/layout/discord.svg"}
        />
      </a>
      <a
        href="https://zyphergames.substack.com"
        target="_blank"
        rel="noreferrer"
      >
        <SvgComponent
          className="community_svg"
          src={preStaticUrl + "/img/layout/medium.svg"}
        />
      </a>
      <a href="https://github.com/zypher-network" target="_blank" rel="noreferrer">
        <SvgComponent
          className="community_svg"
          src={preStaticUrl + "/img/layout/github.svg"}
        />
      </a>
      <a href="https://wiki.zypher.network/" target="_blank" rel="noreferrer">
        <SvgComponent
          className="community_svg"
          src={preStaticUrl + "/img/layout/gitbook.svg"}
        />
      </a>
      <a href="https://coinmarketcap.com/currencies/zypher-network/" target="_blank" rel="noreferrer">
        <SvgComponent
          className="community_svg"
          src="/logos/cmc.svg"
        />
      </a>
    </div>
  );
}, isEqual);
export default CommunityLink;
